export enum SearchTermMetrics {
  COUNT_SEARCH = 'COUNT_SEARCH',
  SEARCH_CONVERSION = 'SEARCH_CONVERSION',
  COUNT_NULL_SEARCH = 'COUNT_NULL_SEARCH',
}

export enum SearchTermGroupBys {
  DATE_PT = 'DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  MONTH_PT = 'MONTH_PT',
  ORDER_SOURCE = 'ORDER_SOURCE',
  SEARCH_TERM = 'SEARCH_TERM',
}
